import React, {useRef} from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {t} from 'i18next';
import ArrButton from '../../../../common/arr-button/ArrButton';
import ArrMenu, {CustomMenuItem} from '../../../../common/arr-menu/ArrMenu';
import {getOperators} from '../operatorMenuUtils';

export interface OperatorButtonProps {
  onOperatorSelected?: (id: string) => void;
  dataTestId: string;
}

const OperatorButton: React.FC<OperatorButtonProps> = ({
  onOperatorSelected,
  dataTestId,
}) => {
  const menuRef = useRef<any>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const openedByThisButtonRef = useRef(false);

  const handleMenuButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    openedByThisButtonRef.current = true;
    menuRef.current?.open(e.currentTarget);
  };

  const handleMenuButtonKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' || e.code === 'Enter') {
      e.stopPropagation();
      menuRef.current?.open(e.currentTarget);
    }
  };

  const handleMenuClose = () => {
    //Commented since causing infinite loop and maximum call stackexceeded error
    //no change in functionality after commenting this line
    // menuRef.current?.close();
  };

  const handleMenuItemClick = (item: CustomMenuItem) => {
    onOperatorSelected && onOperatorSelected(item.id);

    if (openedByThisButtonRef.current) {
      requestAnimationFrame(() => {
        buttonRef.current?.focus();
        openedByThisButtonRef.current = false; // reset
      });
    }
  };

  return (
    <>
      <ArrButton
        ref={buttonRef}
        size="small"
        variant="secondary"
        onClick={handleMenuButtonClick}
        onKeyDown={handleMenuButtonKeyDown}
        className="button-add-operator"
        dataTestId={`button-add-operator-${dataTestId}`}
        endIcon={
          <ArrowDropDownIcon data-testid={`button-end-icon-${dataTestId}`} />
        }
      >
        {t('sessionSearch.queryList.operator')}
      </ArrButton>
      <ArrMenu
        id="operator-menu"
        ref={menuRef}
        items={getOperators()}
        direction="bottom"
        onItemClick={handleMenuItemClick}
        onClose={handleMenuClose}
      />
    </>
  );
};

export default OperatorButton;
